// src/api/apiSuppliers.js
import axios from "../utils/axios";

// Get Suppliers (with pagination & filters)
export const getAllSuppliers = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("suppliers", { params });
    return data;
};

// Get Suppliers for Select Dropdown
export const getSuppliersForSelect = async () => {
    const { data } = await axios.get("suppliers/for-select");
    return data;
};

// Get Single Supplier
export const getSupplier = async (id) => {
    if (!id) return null;
    const { data } = await axios.get(`suppliers/${id}`);
    return data;
};

// Create Supplier
export const createSupplier = async (req) => {
    try {
        const { data } = await axios.post("suppliers", req, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
        });
        return data;
    } catch (error) {
        console.error("createSupplier error:", error);
        throw error;
    }
};

// Update Supplier
export const updateSupplier = async (req, id) => {
    try {
        const { data } = await axios.put(`suppliers/${id}`, req, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
        });
        return data;
    } catch (error) {
        console.error("updateSupplier error:", error);
        throw error;
    }
};

// Soft Delete Supplier
export const deleteSupplier = async (id) => {
    try {
        const { data } = await axios.delete(`suppliers/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteSupplier error:", error);
        throw error;
    }
};

// Mass Soft Delete Suppliers
export const deleteAllSuppliers = async (req = []) => {
    try {
        const { data } = await axios.delete("suppliers/mass-destroy", { data: req }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteAllSuppliers error:", error);
        throw error;
    }
};

// Force Delete Supplier
export const forceDeleteSupplier = async (id) => {
    try {
        const { data } = await axios.delete(`suppliers/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteSupplier error:", error);
        throw error;
    }
};

// Mass Force Delete Suppliers
export const forceDeleteAllSuppliers = async (ids = []) => {
    try {
        const { data } = await axios.delete("suppliers/mass-force-delete", { data: ids }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteAllSuppliers error:", error);
        throw error;
    }
};

// Restore Supplier
export const restoreSupplier = async (id) => {
    try {
        const { data } = await axios.post(`suppliers/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreSupplier error:", error);
        throw error;
    }
};

// Mass Restore Suppliers
export const restoreAllSuppliers = async (req = []) => {
    try {
        const { data } = await axios.post("suppliers/mass-restore", { ...req }, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreAllSuppliers error:", error);
        throw error;
    }
};
